export const setModalState = ({ type }) => {
	return {
		type
	};
};
